import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useExtra } from 'apps/auth/hooks/selectors';
import { useQuery } from 'apps/auth/hooks/useQuery';

import { amplitudeEvent, deliveryIcon, getHref } from './deliveryMethodUtils';
import { PanelButton } from '../../components/PanelButton/PanelButton';

const CompactDeliveryMethod = (props) => {
    const { pocket, toCountry, toCurrency, bonusAmount, bonusIso } = useExtra();
    const query = useQuery();
    const recipientType = query.get('type');
    const sendUriPostfix = recipientType ? `?type=${recipientType}` : '';
    const pocketId = pocket?.id;
    const toCountryName = toCountry?.nameEn;
    const toCurrencyCode = toCurrency?.code || props.countrySource?.currencyCode;
    const toCountryCode = toCountry?.code;
    const href = getHref(props.deliveryMethod, toCountryCode, toCurrencyCode, pocketId, props.isGA, props.isBonus, sendUriPostfix);
    const popupRef = useRef(null);
    const transferCount = __isBrowser__ ? localStorage.getItem('transferCount') : null;
    const dispatch = useDispatch();

    const getDeliveryMethodName = (deliveryMethod, countrySource, title, isProd) => {
        if (isProd) {
            return title;
        }

        return `[${deliveryMethod}] [${countrySource.categoryId}] [${countrySource.prvId}]  ${title}`;
    };

    return (
        <li
            onClick={() => {
                amplitudeEvent(props.isGA, toCountryName, props.deliveryMethod, recipientType, toCurrencyCode, props.payoutMethodCategory, transferCount);
                sessionStorage.setItem('allow_payout_marketing_info', 'true');
            }}
        >
            <PanelButton
                href={href}
                onClick={(e) => {
                    if (props.isBonus && Number(props.commission.restrictionFrom.minAmount) > Number(bonusAmount)) {
                        e.preventDefault();
                        popupRef.current?.open(
                            <SimplePopup
                                text={resolveArguments(props.messages.insufficientBonusFunds, [props.commission.restrictionFrom.minAmount + ' ' + bonusIso])}
                                popupRef={popupRef}
                            >
                                <PopupButton
                                    iconName="check"
                                    text={props.messages.gotIt}
                                    onClick={() => {
                                        popupRef.current?.close();
                                    }}
                                />
                            </SimplePopup>,
                        );
                    } else {
                        dispatch(toggleSpinner(true));
                    }
                }}
                icon={deliveryIcon(props.deliveryMethod, toCountryCode)}
                mainText={getDeliveryMethodName(props.deliveryMethod, props.countrySource, props.countrySource.title, __isProd__)}
                secondaryText={props.countrySource.subtitle}
                dataTestId={`delivery-method-${toLowerCase(props.deliveryMethod)}`}
                badge={props.badge}
            />
            <PopupNew ref={popupRef} />
        </li>
    );
};

export default CompactDeliveryMethod;
